import arrow from '@/assets/arrow.png'
import method_draw from '@/assets/method-draw.png'
import surplus_size from '@/assets/surplus_size.png'
import surplus_tag from '@/assets/surplus_tag.png'

// 小板标签模板数据
export const partTemSetData = [
  {
    name: 'printPage.editPage.text',
    url: 'icon-text',
    type: 'FixedText',
  },
  {
    name: 'printPage.editPage.dataSource',
    url: 'icon-data',
    type: 'DataSource',
  },
  {
    name: 'printPage.editPage.graph',
    url: 'icon-graph',
    type: 'Graphics',
  },
  {
    name: 'printPage.editPage.typograpyPic',
    url: 'icon-typesetting',
    type: 'Typography',
  },
  {
    name: 'printPage.editPage.barCode',
    url: 'icon-bar_code',
    type: 'Onecode',
  },
  {
    name: 'printPage.editPage.QRCode',
    url: 'icon-qr_code',
    type: 'QRcode',
  },
  {
    name: 'printPage.editPage.plankMark',
    url: 'icon-xuhao',
    type: 'wardrobeNum',
  },
  {
    name: 'printPage.editPage.holeSlotPic',
    url: 'icon-kongcao',
    type: 'holeSlotPicture,sideMachiningSequenceDiagram', //孔槽图与侧面加工顺序图
  },
  {
    name: 'printPage.editPage.table',
    url: 'icon-biaogebeifen',
    type: 'Table',
  },
  {
    name: 'printPage.editPage.edgeBandPic',
    url: '',
    imgUrl: method_draw,
    type: 'EdgeBand',
  },
  {
    name: 'printPage.editPage.visibleEdgePic',
    url: '',
    imgUrl: arrow,
    type: 'VisibleEdge,FrontEdge', //见光边与前封图
  },
]

// 裁剪余料标签模板数据
export const cutSurplusTemSetData = [
  {
    name: 'printPage.editPage.text',
    url: 'icon-text',
    type: 'FixedText',
  },
  {
    name: 'printPage.editPage.dataSource',
    url: 'icon-data',
    type: 'DataSource',
  },
  {
    name: 'printPage.editPage.surplusMark',
    url: '',
    type: 'Marking',
    imgUrl: surplus_tag,
  },
  {
    name: 'printPage.editPage.typograpyPic',
    url: 'icon-typesetting',
    type: 'Typography',
  },
  {
    name: 'printPage.editPage.barCode',
    url: 'icon-bar_code',
    type: 'Onecode',
  },
  {
    name: 'printPage.editPage.QRCode',
    url: 'icon-qr_code',
    type: 'QRcode',
  },
  {
    name: 'printPage.editPage.surplusSizePic',
    url: '',
    type: 'SurplusSize',
    imgUrl: surplus_size,
  },
]

// 废料余料标签模板数据
export const wasteSurplusTemSetData = [
  {
    name: 'printPage.editPage.text',
    url: 'icon-text',
    type: 'FixedText',
  },
  {
    name: 'printPage.editPage.dataSource',
    url: 'icon-data',
    type: 'DataSource',
  },
  {
    name: 'printPage.editPage.surplusMark',
    url: '',
    type: 'Marking',
    imgUrl: surplus_tag,
  },
  {
    name: 'printPage.editPage.typograpyPic',
    url: 'icon-typesetting',
    type: 'Typography',
  },
  {
    name: 'printPage.editPage.QRCode',
    url: 'icon-qr_code',
    type: 'QRcode',
  },
]
